import React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import userLogo from 'assets/images/user.png'; 
import logoHome from 'assets/images/logo-home.png';
import logo from 'assets/images/logo.png';
import {translate,resolveRouterPath,getUpdatedPageUrl,gotoUrl, isAdminSession} from 'utils/common';
import {TOGGLE_LEFTMENU,USER_TKEY,DEFAULT_LANDING_PAGE,NOTIFICATIONS_COUNT,SHOW_LOGIN,USER_SIGN_OUT,USER_PROFILE, SHOW_LOADER, USER_SIGNIN, PROFILE_UPDATED, PATH_PREFIX} from 'utils/constants'; 
import dataService from 'utils/dataservice';  
import LanguageSwitch from 'components/languageswitch';
import {getFromCache} from 'utils/querystring';
import LoginModal from './loginmodal';
class NavItems extends React.Component{
    constructor(props){
        super(props);
        this.toggleLoginForm = this.toggleLoginForm.bind(this);
        this.userSignOut = this.userSignOut.bind(this);
        this.gotoProfile = this.gotoProfile.bind(this);
        this.showNotification = this.showNotification.bind(this);
        this.updateNoficationCount = this.updateNoficationCount.bind(this);
        this.profileUpdated = this.profileUpdated.bind(this);
        this.loadNotification = this.loadNotification.bind(this);
        this.state={notificationCount:0, isDropDownOpen: false};
        const ev = {};
        ev[NOTIFICATIONS_COUNT] = this.updateNoficationCount;
        ev[PROFILE_UPDATED] = this.profileUpdated;
        app.events.subscribe(ev);
        
    }
    componentDidMount(){
       if(this.props.signedIn && getFromCache(USER_TKEY))this.loadNotification();
    }
    componentDidUpdate(prevProps){
        //if(this.props.signedIn && (this.state.notificationCount==0 || (this.props.signedIn != prevProps.signedIn) && getFromCache(USER_TKEY))){
        if(this.props.signedIn && this.props.signedIn != prevProps.signedIn && getFromCache(USER_TKEY)){
            this.loadNotification();
        }
    }
    loadNotification(){
        let postdata = {page:1, itemsPerPage: 10,tab: "PENDING", search:{}} 
        // dataService.postRequest('notifications', postdata).then(res => { 
        //     this.setState({notificationCount:res.totalCount?res.totalCount:0}) 
        // });
    }
    showNotification(e){
    }
    updateNoficationCount([params]){
        this.setState({notificationCount:params.count})
    }
    
    profileUpdated([params]){
        this.setState({shopName:params.shopname});
    }    
    
    toggleLoginForm() {
        this.setState(prevState => ({
            isDropDownOpen: !prevState.isDropDownOpen
        }));
    }

    userSignOut() {
        app.events.trigger(USER_SIGN_OUT);
        this.setState({ email: '', fullName: '', isDropDownOpen: false });
    }

    gotoProfile(){
        this.setState({isDropDownOpen: false });
        gotoUrl(resolveRouterPath("myaccount",{}));
    }
    
    render(){
        let myaccountDisplayNname = (this.state.shopName || (app.userAuth && app.userAuth.contactShopName)) || translate('account.my_account')
        let trunkatedDisplayNname = myaccountDisplayNname.length >18 ?myaccountDisplayNname.replace(myaccountDisplayNname.substring(16, myaccountDisplayNname.length),'...'):myaccountDisplayNname
        return(
            <React.Fragment>
                <div className="header-items">
                        <ul className="header-items-list">
                            {/* {!app.userAuth.isAdmin && <li className="notify">
                                <a onClick={this.showNotification}>
                                    <span className="items-wrap">
                                        <sup className={"badge-sup "+(this.state.notificationCount==0?'no-item':'')}>{this.state.notificationCount}</sup>
                                        <i className="far fa-bell"></i>
                                    </span>
                                    <span className="items-text">{translate('notification')}</span>
                                    
                                </a>
                            </li>} */}
                            
                            <li className="user">
                                {/* {this.state.email &&  */}
                                     <Dropdown isOpen={this.state.isDropDownOpen} toggle={this.toggleLoginForm}>
                                        <DropdownToggle tag="a" className="btn btn-sign-in dropdown-toggle">
                                            {/* <i className="far fa-user"></i>  */} 
                                            <span className="items-wrap">
                                                {/* <img className="user-img rounded-circle" src={userLogo}/> */}
                                                <i className="icon-profile"></i>
                                            </span>                                                    
                                            <span className="items-text" title={myaccountDisplayNname}>{trunkatedDisplayNname}</span>
                                            {/* <i className="far fa-user"></i> <span className="user-name">{translate('account.my_account')}</span> */}
                                        </DropdownToggle>
                                        <DropdownMenu className="p-3 dropdown-menu-center">
                                            {/* {this.state.email &&  */}
                                            <React.Fragment>
                                                {/* <a className="dropdown-item cu-pointer" type="my-profile" 
                                                    onClick={this.gotoProfile}>
                                                    {translate('userprofile.my_profile')}
                                                </a>  */}
                                                {/* <a className="dropdown-item cu-pointer" type="reset-password" onClick={ this.selectMenu}>{translate('buyer.account.change_pwd')}</a> */}
                                                {/* <div className="dropdown-divider"></div> */}
                                                <button className="btn btn-secondary btn-block mt-3 p-2" onClick={this.userSignOut}>{translate('signout')}</button>
                                            </React.Fragment>
                                            {/* } */}
                                            {/* {!this.state.email && <Login signIn id="login-form-dropdown" header fieldPrefix="login" nextStep={this.toggleLoginForm} />} */}
                                        </DropdownMenu>
                                    </Dropdown> 
                                 {/* <div className="btn-group">
                                    <a type="button" className="btn btn-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <img className="user-img rounded-circle" src={userLogo}/>
                                        {translate('username')}
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-right">
                                        <a className="dropdown-item" type="button">Sign Out</a>
                                    </div>
                                </div> 
                                  } */}
                            </li>
                            {/* <li className="language">                                 
                                    <LanguageSwitch value={app.selectedLocale}/>                                 
                            </li>   */}
                        </ul>
                    </div>
            </React.Fragment>
        )
    }
}
class Header extends React.Component {
    constructor(props) {
        super(props);
        // this.state={modal:false};
        this.state={ showLogInModal:false, menuOpen: false};
        this.toggleLoginModal = this.toggleLoginModal.bind(this);
        this.toggleResMenu = this.toggleResMenu.bind(this);        
        this.regnCallBack = this.regnCallBack.bind(this);    
        this.handleLogoClick = this.handleLogoClick.bind(this);    
        this.menuClick = this.menuClick.bind(this);
        app.events.subscribe({ 
            [SHOW_LOGIN]: this.toggleLoginModal 
        }, this, -1);    
    }
    // toggleModal(){
    //     this.setState({modal: !this.state.modal})
    // }
    componentDidMount() {
        // console.log('-----header mouted------');
        ///auto SignIn chk For local development
        if(app.autoSignIn) this.toggleLoginModal();
    }  
    toggleResMenu(){
        app.events.trigger(TOGGLE_LEFTMENU);
    }
    toggleLoginModal(){
        this.setState({showLogInModal: !this.state.showLogInModal})
    }
    regnCallBack(data){
        app.events.trigger(SHOW_LOADER, { status: true});
        dataService.postRequest("userSignin",data).then(res=>{                
            app.events.trigger(SHOW_LOADER, { status: false});
            if(res["status"] && res["status"] == "success") {
                // if(res.supplierId){
                    let userdata = res.userdata;
                    let userAuth = {...(res.appAuthTokenTO || {}), ...userdata};
                    // userAuth.authUserId = userdata.userId;        
                    ///TODO remove use of app.userAuth.userId across portal
                    // userAuth.userId = res.supplierId;
                               
                    // userAuth.supplierId = res.supplierId;
                    // userAuth.econtactId = res.econtactId;
                    app.events.trigger(USER_SIGNIN,userAuth,'login');
                    // this.props.nextStep({},userAuth,'login',this.signIn);
                // }
            }
        }).catch((error) => {
            app.events.trigger(SHOW_LOADER, { status: false});
            // this.setState({error: error ?error.message:'Error!'}); 
        }); 
    }
    handleLogoClick(){
        if(this.props.signedIn){
            gotoUrl(resolveRouterPath(DEFAULT_LANDING_PAGE,{lang:app.selectedLocale}))
        }else window.location.href = location.origin+PATH_PREFIX+'login';
    }
    menuClick(){
        this.state.menuOpen ? this.setState({menuOpen: false}) : this.setState({menuOpen: true});
    }

    render(){
        let {isRegnPage, signedIn} = this.props;
        return(
            <React.Fragment>
                {/* {!this.props.signedIn && <div className="badge-panel">} */}
                {/* <div className="container-fluid">
                        <div className="clearfix pad">
                            <div className="badge-items d-flex justify-content-end align-items-center">
                                
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className="header-panel fixed-top">
                    <div className="container-fluid">
                        <div className="navbar-toggler-wrap">
                            <button className="navbar-toggler btn" onClick={()=>this.toggleResMenu()} type="button" data-toggle="offcanvas">
                                <i className="fas fa-bars"></i>
                            </button>
                        </div>
                        <div className="logo">
                            <a onClick={this.handleLogoClick} title="SCG - DAM">
                                <i  onClick={this.handleLogoClick} className="icon-scg-dam-logo1"></i>
                            </a>
                        </div>
                        {/* <nav className="navbar navbar-expand-md header-menu p-0 " >
                            <a onClick={this.menuClick} className="navbar-toggler btn lg p-0" data-toggle="offcanvas">
                                <i className="fas fa-bars"></i>
                            </a>

                            <div className={"navbar-collapse offcanvas-collapse"+ (this.state.menuOpen? ' open ': '')} id="navbarsExampleDefault">
                                <ul className="navbar-nav">
                                    {
                                        this.props.headerLinks && this.props.headerLinks.map((link, index) =>
                                            <li className="nav-item active" key={"nav-item" + index}>
                                                <a className="nav-link" onClick={this.menuClick} href={link.link}>{translate(link.text)}</a>
                                            </li>
                                        )
                                    }
                                </ul>
                            </div>
                        </nav> */}
                        <div className="d-flex signinwrap">
                            {/* {!signedIn && !isRegnPage && <div className="signin">  
                                <a className="btn btn-primary lg link-signin" onClick={this.toggleLoginModal}>
                                    <i className="icon-profile"></i><span>{translate('signin')}</span>
                                </a> 
                            </div>}
                            {!signedIn && this.state.showLogInModal && 
                                <LoginModal {...this.props} 
                                regnCallBack={this.regnCallBack}
                                closeModal={this.toggleLoginModal}/> }
                                 */}
                            {/* <Account/> */} 
                            {signedIn && <NavItems signedIn={signedIn}/>}

                            {/* {!signedIn && !isRegnPage && <div className="lang-home ml-4 d-flex align-items-center">
                                <LanguageSwitch value={app.selectedLocale}/>
                            </div>
                            } */}
                        </div>
                       

                        
                    </div>
                </div>
            </React.Fragment>
        );
    }    
}

export default Header;
